<template>
    <div style="display: flex; flex-direction: column;" id="agreement_contents_print_wrap">
        <div ref="wrapper" style="flex: 1; padding: 20px; overflow-y: scroll;">
            <div style="line-height: 24px;">본인은 귀 사업장에서 지급하는 임금을 아래 계좌로 수령하는 것에 동의합니다.</div>
            <div style="margin-top: 30px;">
                <div class="form-group">
                    <label>예금주</label>
                    <input type="text" readonly :value="member_name">
                </div>
                <div class="form-group">
                    <label>계좌번호</label>
                    <input type="text" readonly :value="bank_name">
                </div>
                <div class="form-group">
                    <label>은행명</label>
                    <input type="text" readonly :value="bank_account">
                </div>
                <div class="form-group">
                    <label>동의사유</label>
                    <input type="text" placeholder="예) 본인계좌 사용불가">
                </div>
            </div>
            <div style="line-height: 24px; margin-top: 30px;">본 동의서는 본인의 요청에 의한 자발적 의사로 작성 되었으며, 이로 인해 발생할 수 있는 문제는 본인이 책임지는 것에 동의합니다</div>
            <div style="margin-top: 20px;">
                <div style="margin-bottom: 10px;">근로자 성명: {{ member_name }}xx</div>
                <div style="margin-bottom: 10px;">날짜: {{ today }}</div>
                <div style="margin-top:20px;">
                    <div>
                        <div style="margin-bottom: 10px;">마우스/손 으로 서명해주세요</div>
                        <canvas id="signCanvas" style="background-color: rgba(200,200,200, 0.5); width: 100%; border-radius: 4px;"></canvas>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" :value="agree_str" id="checkbox_arr_str">
    </div>
</template>

<script>
import moment from "moment"
import {BANKS} from "../../Constants";

export default {
    name: "WagesAgreementContents",
    components: {

    },
    computed: {
        agree_str() {
            return [this.isSigned, this.pageHeight].join(',');
        },
        member_name(){
            return this.$route.query.name;
        },
        bank_name(){
            return this.$route.query.bank_name;
        },
        bank_account(){
            return this.$route.query.bank_account;
        }
    },
    data() {
        return {
            today: '',
            name: '',
            isSigned: false,
            pageHeight: 0,
            BANKS : BANKS,
        }
    },
    methods: {

    },
    mounted() {
        const that = this;

        /*eslint-disable no-undef */
        (function (obj) {
            obj.init();
            $(obj.onLoad);
        })((function () {
            var canvas = $('#signCanvas');
            var div = canvas.parent("div");
            var ctx = canvas[0].getContext("2d");
            var drawble = false;

            function canvasResize() {
                canvas[0].height = div.height();
                canvas[0].width = div.width();
            }
            function draw(e) {
                function getPosition() {
                    return {
                        X: e.pageX - canvas.offset().left,
                        Y: e.pageY - canvas.offset().top
                    }
                }

                switch (e.type) {
                    case "mousedown": {
                        that.isSigned = true;
                        drawble = true;
                        ctx.beginPath();
                        ctx.moveTo(getPosition().X, getPosition().Y);
                    }
                        break;
                    case "mousemove": {
                        if (drawble) {
                            ctx.lineTo(getPosition().X, getPosition().Y);
                            ctx.stroke();
                        }
                    }
                        break;
                    case "mouseup":
                    case "mouseout": {
                        drawble = false;
                        ctx.closePath();
                    }
                        break;
                }
            }
            function touchdraw(e) {
                function getPosition() {
                    return {
                        X: e.changedTouches[0].pageX - canvas.offset().left,
                        Y: e.changedTouches[0].pageY - canvas.offset().top
                    }
                }

                switch (e.type) {
                    case "touchstart": {
                        that.isSigned = true;
                        drawble = true;
                        ctx.beginPath();
                        ctx.moveTo(getPosition().X, getPosition().Y);
                    }
                        break;
                    case "touchmove": {
                        if (drawble) {
                            e.preventDefault();
                            ctx.lineTo(getPosition().X, getPosition().Y);
                            ctx.stroke();
                        }
                    }
                        break;
                    case "touchend":
                    case "touchcancel": {
                        drawble = false;
                        ctx.closePath();
                    }
                        break;
                }
            }
            return {
                init: function () {
                    canvas.on("mousedown", draw);
                    canvas.on("mousemove", draw);
                    canvas.on("mouseup", draw);
                    canvas.on("mouseout", draw);
                    canvas.on("touchstart", touchdraw);
                    canvas.on("touchend", touchdraw);
                    canvas.on("touchcancel", touchdraw);
                    canvas.on("touchmove", touchdraw);
                },
                onLoad: function () {
                    canvasResize();
                }
            }
        })());
        this.$nextTick(() => {
            this.pageHeight = this.$refs.wrapper.scrollHeight
        })
    },
    created() {
        const today = moment().format('YYYY-MM-DD')
        this.today = today
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
}


select {
    width: 100%;
    padding: 0px 6px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
    background-color: white;
    color: black;
}

button {
    padding: 8px 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: 44px;
}

button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}
</style>